import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { fillAverageTrueRange } from "../math/trueRange";

/** Average True Range (research §1.4), as TV Average True Range: RMA of the true range. */
export default {
  id: "average-true-range",
  name: "Average True Range",
  isOscillator: true,
  inputs: [
    periodInput("period", "Period", 14),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.BLUE),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    fillAverageTrueRange({ bars, target: series.value, period, fromIndex });
  },
};
